// services/site.js
import axiosInstance from './axiosInstance';

const SITE_API_URL = '/site';

const siteService = {
  async getPermissions(idempresa) {
    try {
      const response = await axiosInstance.get(`${SITE_API_URL}/permissions/get.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
};

export default siteService;
